"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fade = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var react_overlays_1 = require("../react-overlays");
var Fade = /** @class */function (_super) {
  __extends(Fade, _super);
  function Fade() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Fade.prototype.render = function () {
    var timeout = this.props.timeout;
    return react_1.default.createElement(react_overlays_1.Transition, __assign({}, this.props, {
      timeout: timeout,
      className: classnames_1.classNames(this.props.className, 'fade'),
      enteredClassName: "in",
      enteringClassName: "in"
    }), this.props.children);
  };
  Fade.propTypes = {
    in: prop_types_1.default.bool,
    unmountOnExit: prop_types_1.default.bool,
    transitionAppear: prop_types_1.default.bool,
    timeout: prop_types_1.default.number,
    onEnter: prop_types_1.default.func,
    onEntering: prop_types_1.default.func,
    onEntered: prop_types_1.default.func,
    onExit: prop_types_1.default.func,
    onExiting: prop_types_1.default.func,
    onExited: prop_types_1.default.func,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node
  };
  Fade.defaultProps = {
    in: false,
    timeout: 300,
    unmountOnExit: false,
    transitionAppear: false
  };
  return Fade;
}(react_1.default.Component);
exports.Fade = Fade;